import { combineReducers } from 'redux';
import { reducer as salesChannelsAppsReducer } from './SalesChannelsApps';

const salesChannelsReducers = combineReducers({
  salesChannelsApps: salesChannelsAppsReducer,
});

export default salesChannelsReducers;
